'use strict';

var React = require('react');
var component = require('../Control/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const ReadOnlyControl = React.forwardRef(({ value, ...props }, ref) => (React__default.default.createElement(component.Control, { as: "div", ...props, ref: ref, disabled: true },
    value,
    "\u00A0")));

exports.ReadOnlyControl = ReadOnlyControl;
//# sourceMappingURL=component.js.map
